// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".responsabilityFooter[data-v-d401eaf4]{width:100%;min-height:320px;background-color:#131313;color:#131313;background-size:cover}.responsabilityFooter hr[data-v-d401eaf4]{width:50px;border-color:#ffc9c4}.responsabilityFooter div[data-v-d401eaf4]{width:50%;text-align:center}.responsabilityFooter .link[data-v-d401eaf4]{color:#ffc9c4}.responsabilityFooter h3[data-v-d401eaf4]{color:#4e4e4e}", ""]);
// Exports
module.exports = exports;
